import React from "react";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";

const StyledCheckbox = styled(Checkbox)({
  color: "#888",
  padding: "3px",
  "&.Mui-checked": {
    color: "#007bff",
  },
  fontFamily: "Inter !important",
});

const StyledLabel = styled(FormControlLabel)({
  "& .MuiTypography-root": {
    fontWeight: "400",
    fontFamily: "Inter !important",
    fontSize: "12px",
    color: "#667085"
  },
});

const CustomCheckboxList = ({ columns, selectedColumns, handleColumnToggle }) => {
  return (
    <>
      <Stack>
        {columns.map((column) => (
          <StyledLabel
            key={column.id}
            control={
              <StyledCheckbox
                checked={selectedColumns.some((col) => col.id === column.id)}
                onChange={() => handleColumnToggle(column.id)}
              />
            }
            label={column.label}
          />
        ))}
      </Stack>
    </>
  );
};

export default CustomCheckboxList;
